import { default as _axios } from "axios";

let baseURL = `https://api.${window.location.hostname}/`;

const axiosApiInstance = _axios.create({
  baseURL: baseURL,
});

export const axios = axiosApiInstance;
